// resources/js/router/app.js
import { createRouter, createWebHistory } from 'vue-router'
import store from '../vuex/app'

// Lazy-load all pages (smaller initial bundle)
const Home = () => import('../pages/app/Home.vue')
const ForgotPassword = () => import('../pages/app/ForgotPassword.vue')
const AdminLogin = () => import('../pages/app/AdminLogin.vue')
const SSOLogin = () => import('../pages/app/SSOLogin.vue')
const PatientLogin = () => import('../pages/app/PatientLogin.vue')
const ResponsiblePartyLogin = () => import('../pages/app/ResponsiblePartyLogin.vue')
const Sign = () => import('../pages/app/Sign.vue')

// OPTION A: Keep your existing Dashboard.vue as the wrapper for children
const Dashboard = () => import('../pages/app/Dashboard.vue')
const InProgressAdmissions = () => import('../pages/app/components/InProgressAdmissions.vue')
const CompletedAdmissions = () => import('../pages/app/components/CompletedAdmissions.vue')
const Uploads = () => import('../pages/app/components/Uploads.vue')
const OtherPatients = () => import('../pages/app/components/OtherPatients.vue')

// OPTION B (alternative): If you created a Vuetify admin shell like AdminLayout.vue,
// you can swap Dashboard above with: const Dashboard = () => import('@/components/admin/AdminLayout.vue')

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: { showNav: false },
  },
  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    component: ForgotPassword,
    meta: { showNav: true },
  },
  {
    path: '/admin/login',
    name: 'AdminLogin',
    component: AdminLogin,
    meta: { showNav: true },
  },
  {
    path: '/admin/ssoLogin',
    name: 'SSOLogin',
    component: SSOLogin
  },
  {
    path: '/patient/login',
    name: 'PatientLogin',
    component: PatientLogin,
    meta: { showNav: true },
  },
  {
    path: '/signer/login',
    name: 'ResponsiblePartyLogin',
    component: ResponsiblePartyLogin,
    meta: { showNav: true },
  },

  // Admin area (wrapped layout + child pages)
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: Dashboard,               // Option A: your Dashboard.vue acts as layout
    meta: { showNav: true, requiresAuth: true },
    children: [
      {
        path: '',
        redirect: { name: 'InProgressAdmissions' }, // cleaner than absolute path
      },
      {
        path: 'in-progress-admissions',
        name: 'InProgressAdmissions',
        component: InProgressAdmissions,
        meta: { requiresAuth: true },
      },
      {
        path: 'completed-admissions',
        name: 'CompletedAdmissions',
        component: CompletedAdmissions,
        meta: { requiresAuth: true },
      },
      {
        path: 'uploads',
        name: 'Uploads',
        component: Uploads,
        meta: { requiresAuth: true },
      },
      {
        path: 'other-patients',
        name: 'OtherPatients',
        component: OtherPatients,
        meta: { requiresAuth: true },
      },
    ],
  },

  // Signature route (no nav)
  {
    path: '/sign/:id/:signatureId',
    name: 'Sign',
    component: Sign,
    meta: { showNav: false },
    props: true,
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior() {
    return { top: 0, left: 0, behavior: 'smooth' }
  },
})

// Simple auth guard
router.beforeEach((to, _from, next) => {
  const isAuthed = store.getters['store/isAuthenticated']
  if (to.matched.some(r => r.meta?.requiresAuth) && !isAuthed) {
    // send unauthenticated users to the most relevant login
    return next({ name: 'AdminLogin', query: { redirect: to.fullPath } })
  }
  next()
})

export default router
